import { render, staticRenderFns } from "./AutocompleteChoiceUser.vue?vue&type=template&id=0b07c705&scoped=true"
import script from "./AutocompleteChoiceUser.vue?vue&type=script&lang=js"
export * from "./AutocompleteChoiceUser.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteChoiceUser.vue?vue&type=style&index=0&id=0b07c705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07c705",
  null
  
)

export default component.exports